import React from 'react';
import LoginPage from './pages/LoginPage/LoginPage';
import GamePage from './pages/GamePage/GamePage';
import ToastifyContainer from './components/Toastify/ToastifyContainer';
import { CheckLandscape } from './components/CheckLandscape/CheckLandscape';
import { useOrientationStore } from './stores/orientationStore';
import { useLoginStateStore } from './stores/loginStateStore';
import './App.css';



function App() {
  const isLandscape = useOrientationStore(s => s.isLandscape);

  return (
    <div className="App">
      <CheckLandscape />
      {isLandscape ? <Landscape /> : <Portrait />}
    </div>
  );
}


function Portrait() {
  return (
    <div style={{color:"white", padding:5}}>turn the phone in landscape mode</div>
  )
}


function Landscape() {
  const loginToken = useLoginStateStore(s => s.loginToken);

  return (
    <>
      <ToastifyContainer />
      {loginToken === "" ? <LoginPage /> : <GamePage />}
    </>
  )
}




export default App;
